import React from 'react'

import '../styles/menuicon.css'


const MenuIcon = props => {

    return (
        <button className='menu-button' onClick={props.toggleDrawer} >
            <div className='menu-icon' />
            <div className='menu-icon' />
            <div className='menu-icon' />
        </button>


    )


}

export default MenuIcon